export const urlifyTitle = (title: string): string => {
  return title
    .replace(/[^a-zA-Z0-9- ]/g, '')
    .replace(/ {2}/g, ' ')
    .split(' ')
    .join('-')
    .toLowerCase();
};
